import axios from 'axios';
import { saveBidMode } from '../../scenes/BidSession/helpers.js';
import * as actionTypes from './actionTypes';
import apiCall from '../app/apiCall';
import { BID_TYPES, DISPLAY_ADD_DAY_OFF_ID, DISPLAY_REQUEST_ALL_ID } from './../constants/index';
import { BidMode, sortPreferences } from "../../scenes/BidSession/helpers";
import { buildUrlWithAdminImpersonation, getBidSessionsUrl } from '../../utilities/helpers';

const getCommonLabels = () => (sessionStorage.getItem('lng') === 'fr'
  ? require('./../../labels/labels.french.json')
  : require('./../../labels/labels.json')).commonLabels;
export const fetchBidSessionRequest = () => ({
  type: actionTypes.FETCH_BID_SESSION_REQUEST
});
export const fetchBidSessionFailure = message => ({
  type: actionTypes.FETCH_BID_SESSION_FAILURE,
  message
});
export const fetchBidSessionSuccess = bidSession => ({
  type: actionTypes.FETCH_BID_SESSION_SUCCESS,
  bidSession
});
export const updateBidSessionSuccess = bidSession => {
  return {
    type: actionTypes.UPDATE_BID_SESSION_SUCCESS,
    bidSession
  };
};
export const clearData = () => ({ type: actionTypes.CLEAR_DATA });
export const fetchmode = bidmode => ({
  type: actionTypes.FETCH_BID_MODE_SUCCESS,
  bidmode
});
export function savePreference(bidPreference) {
  return () => {
    const savePreferenceUrl = buildUrlWithAdminImpersonation('preferences/save');
    return apiCall(savePreferenceUrl, 'post', bidPreference);
  };
}

export function fetchCrewGroups() {
  return () => {
    const fetchUrl = `preferences/crew-group-bid-sessions`;
    return apiCall(fetchUrl);
  };
}

export function updateAllScores(preferencesWithScores) {
  return () => {
    const baseUrl = 'preferences/updateScores';
    const updateScoresUrl = buildUrlWithAdminImpersonation(baseUrl);

    const basicPreferences = [];
    preferencesWithScores.forEach(preference => {
      const item = {
        bidSessionId: preference.bidSessionId,
        staffId: preference.staffId,
        employeeBidId: preference.employeeBidId,
        bidAggregateId: preference.bidAggregateId,
        bidSessionSnapshotId: preference.bidSessionSnapshotId,
        preferenceOptionId: preference.preferenceOptionId,
        preferenceOptionPropertyId: preference.preferenceOptionPropertyId,
        score: preference.score
      };
      basicPreferences.push(item);
    });
    const data = {
      preferences: basicPreferences
    };
    return apiCall(updateScoresUrl, 'post', data);
  };
}

export function orderPreferences(preferences) {
  preferences.entries = sortPreferences(preferences.entries);
  return preferences;
}

export function switchPriority(bidAggregateIds, bidAggregateIdsToSwitchWith) {
  return () => {
    const baseUrl = 'preferences/bids/priority/switch';
    const url = buildUrlWithAdminImpersonation(baseUrl);
    const data = {
      bidAggregateIds,
      bidAggregateIdsToSwitchWith
    };
    return apiCall(url, 'put', data);
  };
}

export function updateScore(preference, newScore) {
  return () => {
    const baseUrl = 'preferences/bids/priority/update';
    const url = buildUrlWithAdminImpersonation(baseUrl);
    const data = {
      bidSessionId: preference.bidSessionId,
      staffId: preference.staffId,
      employeeBidId: preference.employeeBidId,
      bidAggregateId: preference.bidAggregateId,
      bidSessionSnapshotId: preference.bidSessionSnapshotId,
      preferenceOptionId: preference.preferenceOptionId,
      preferenceOptionPropertyId: preference.preferenceOptionPropertyId,
      score: newScore
    };
    return apiCall(url, 'put', data);
  };
}
export function reorderReserveline(staffId, bidSessionId, categoryId, reordereddata) {
  return () => {
    const baseUrl = 'preferences/reserveline';
    const url = buildUrlWithAdminImpersonation(baseUrl);
    const data = {
      staffId: staffId,
      bidSessionId: bidSessionId,
      categoryId: categoryId,
      bidderReserveLines: reordereddata
    };
    return apiCall(url, 'put', data);
  }

}
export function updateWeight(preference, newScore, bidMode, prefIds) {
  return () => {
    const baseUrl = `preferences/bids/weight/update/?bidMode=${bidMode}`;
    const url = buildUrlWithAdminImpersonation(baseUrl);
    const data = {
      bidSessionId: preference.bidSessionId,
      staffId: preference.staffId,
      bidAggregateIds: prefIds,
      score: newScore,
      bidMode: bidMode
    };
    return apiCall(url, 'put', data);
  };
}

export function updateWeightForAll(preference, newScore, bidMode, prefIds) {
  return () => {
    const baseUrl = `preferences/bids/weight/update-all/?bidMode=${bidMode}`;
    const url = buildUrlWithAdminImpersonation(baseUrl);
    const data = {
      bidSessionId: preference.bidSessionId,
      staffId: preference.staffId,
      bidAggregateIds: prefIds,
      score: newScore,
      bidMode: bidMode
    };
    return apiCall(url, 'put', data);
  };
}

export function updateOtherOption(otherOptionCode, data) {
  return () => {
    const baseUrl = `preferences/options/other/${otherOptionCode}`;
    const url = buildUrlWithAdminImpersonation(baseUrl);
    return apiCall(url, 'put', data);
  };
}

export function getReserveLineType(bidSessionId, staffId, categoryId) {
  return () => {
    const reservelinetypesUrl = `preferences/reserveline?bidsession_id=${bidSessionId}&staff_id=${staffId}&category_id=${categoryId}`;
    return apiCall(reservelinetypesUrl);
  };
}

export function getPreferencesOptionsIds(data) {
  if (!data) return [];
  if (Object.keys(data).length === 0) return [];
  return data.entries.map(option => option.preferenceOptionId);
}

export function getNextAvailableLevel(
  bidPreferences,
  bidLevels,
  allowDuplicates
) {
  const maxReducer = (max, bidPreference) => Math.max(max, bidPreference.score);
  const computeNextLevel = maxScore => {
    return bidLevels.entries
      .map((level, index) => {
        if (level === maxScore) {
          if (allowDuplicates) {
            return maxScore;
          }
          if (index >= bidLevels.entries.length - 1) {
            return bidLevels.entries[bidLevels.entries.length - 1];
          }
          return bidLevels.entries[index + 1];
        }
      })
      .find(entry => entry !== undefined);
  };

  if (bidLevels === undefined || bidLevels.entries.length === 0) {
    return 'There is no configuration for bid ladder levels.';
  }

  if (bidPreferences === undefined || bidPreferences.entries.length === 0) {
    return bidLevels.entries[0];
  }

  const firstScore = bidPreferences.entries[0].score;
  const maxScore = bidPreferences.entries.reduce(maxReducer, firstScore);
  return computeNextLevel(maxScore);
}

export function fetchBidSession(staffId, bidSessionId, applyStandingBid, defaultBid) {
  return dispatch => {
    function getLastSavedDate(
      user,
      currentBid,
      bidPreferences,
      otherOptions,
      filters,
      activePreferenceOptionsIds,
      bidMode,
      bidLevels,
      nextAvailableLevel,
      crewinterfacemode,
      reserveLine,
      configureReserveLineType,
      displayDayOffOption,
      displayRequestOptions,
      displayScope,
      pairings,
      scores,
      layoverHotelInformation
    ) {
      const getLastSavedDateUrl = `preferences/bid-session/${bidSessionId}/employee/${staffId}/last-revision`;
      apiCall(getLastSavedDateUrl)
        .then(response => {
          const lastSavedData = response.data;
          return dispatch(
            fetchBidSessionSuccess({
              user,
              currentBid,
              bidPreferences,
              lastSavedData,
              otherOptions,
              filters,
              activePreferenceOptionsIds,
              bidMode,
              bidLevels,
              nextAvailableLevel,
              crewinterfacemode,
              reserveLine,
              configureReserveLineType,
              displayDayOffOption,
              displayRequestOptions,
              displayScope,
              pairings,
              scores,
              layoverHotelInformation
            })
          );
        })
        .catch(error => dispatch(fetchBidSessionFailure(error)));
    }

    function isWeightMode(bidMode) {
      return BidMode.MANUAL.biddingMode === bidMode
        || BidMode.AUTOMATIC.biddingMode === bidMode;
    }

    function getBidsAndPreferences(user) {
      if (Object.keys(user).length > 0) {
        const categoryId = user.currentCategory.categoryId;
        const applicationType = getCommonLabels().APPLICATION_TYPE;
        const optionPropertyId = BID_TYPES.REGULAR;

        // Params to request bids and preferences.
        const lang = 'fr';
        const baseUserRequestUrl = applyStandingBid
          ? `preferences/bid-session/${bidSessionId}/employee/${staffId}/${lang}/${applyStandingBid}`
          : `preferences/bid-session/${bidSessionId}/employee/${staffId}/${lang}`;
        const userRequestUrl = buildUrlWithAdminImpersonation(baseUserRequestUrl);
        const getOpenBidsUrl = getBidSessionsUrl();
        const getOtherOptionsUrl = buildUrlWithAdminImpersonation(`preferences/options/other?bidsession_id=${bidSessionId}&staff_id=${staffId}&category_id=${categoryId}`);
        const getFiltersUrl = `filters/${categoryId}`;
        const openBidsData = { categoryId };
        const bidModeRequestUrl = `preferences/bid-session-mode?bidsession_id=${bidSessionId}&staff_id=${staffId}`;
        const crewinterfaceurl = 'activities/crewinterface-mode';
        /* Get a list of all the active preference options */
        const getPreferenceOptions = `preferences/options?application_type=${applicationType}&property_code=${optionPropertyId}&bidsession_id=${bidSessionId}&category_id=${categoryId}&staff_id=${staffId}`;

        const bidLevelsUrl = `preferences/bids/ladder/levels/no-error?bidsession_id=${bidSessionId}&staff_id=${staffId}`;
        const duplicatesUrl = `preferences/allow-duplicates?bidsession_id=${bidSessionId}&staff_id=${staffId}`;
        const reservelinetypes = `preferences/reserveline?bidsession_id=${bidSessionId}&staff_id=${staffId}&category_id=${categoryId}`;
        const configureReserveLineTypeURL = `reservelinetype/options`
        const bidScopeRequestUrl = 'preferences/displayEnabled?feature=bidScope'
        const bidScopeOptionPropertyId = 15;
        const getBidScopePreferenceOptions = `preferences/options?application_type=${applicationType}&property_code=${bidScopeOptionPropertyId}&bidsession_id=${bidSessionId}&category_id=${categoryId}&staff_id=${staffId}`;
        const activitiesDetailsUrl = `activities/bid-session/${bidSessionId}/employee/${staffId}/activity`
        const scoresDetailsUrl = `reports/bidder-score?staffId=${staffId}&bidSessionId=${bidSessionId}`
        // Request
        const calls = [
          apiCall(getOpenBidsUrl, 'post', openBidsData),
          apiCall(getOtherOptionsUrl),
          apiCall(userRequestUrl),
          apiCall(getFiltersUrl),
          apiCall(getPreferenceOptions),
          apiCall(bidModeRequestUrl),
          apiCall(bidLevelsUrl),
          apiCall(duplicatesUrl),
          apiCall(crewinterfaceurl),
          apiCall(reservelinetypes),
          apiCall(configureReserveLineTypeURL),
          apiCall(bidScopeRequestUrl),
          apiCall(getBidScopePreferenceOptions),
          apiCall(scoresDetailsUrl)
        ]

        !defaultBid && calls.push(apiCall(activitiesDetailsUrl))

        axios
          .all(calls)
          .then(
            axios.spread(
              (
                respOpenBids,
                respOtherBidOption,
                respBidPreferences,
                respFilters,
                resPreferenceOptions,
                resBidMode,
                respBidLevels,
                respDuplicates,
                rescrew,
                resReservelinetypes,
                resConfigureReserveLineType,
                resBidScopeRequest,
                resBidScopePreferenceOptions,
                resScoresDetails,
                resActivitiesDetail
              ) => {
                const openBids = respOpenBids.data;
                const otherOptions = respOtherBidOption.data;
                const filters = respFilters.data;
                const preferenceOptions = resPreferenceOptions.data;
                let bidMode = resBidMode.data;
                const bidLevels = respBidLevels.data;
                const allowDuplicates = respDuplicates.data;
                const crewinterfacemode = rescrew.data;
                let reserveLine = resReservelinetypes.data;
                let configureReserveLineType = resConfigureReserveLineType.data;
                const bidScopeRequest = resBidScopeRequest.data;
                const bidScopePreferenceOptions = resBidScopePreferenceOptions.data;
                let pairings
                pairings = !defaultBid ? resActivitiesDetail?.data : null;
                const scores = resScoresDetails.data;
                /* Get an array of pairings activities from pairing details which are of type layover */
                let layoverHotelInformation = !defaultBid
                  ? resActivitiesDetail?.data?.flatMap((activity) => {
                    const layoverDetails = activity.pairing?.pairingDetails?.filter((pairingDetail) => pairingDetail.type === "LAYOVER") || []
                    const hasHotelName = layoverDetails.some(pairingDetail => pairingDetail.hotelName !== null);
                    return hasHotelName ? layoverDetails : [];
                  })
                  : null;
                let displayScope = false;
                /* Get an array with only ids of active preference options */
                const activePreferenceOptionsIds =
                  getPreferencesOptionsIds(preferenceOptions);

                // check if we display the add day off in linear calendar
                const displayDayOffOption = activePreferenceOptionsIds.find(id => id === DISPLAY_ADD_DAY_OFF_ID) ? true : false

                // check if we display the request & request all buttons  132 pairing starting on date
                const displayRequestOptions = activePreferenceOptionsIds.find(id => id === DISPLAY_REQUEST_ALL_ID) ? true : false

                const bidPreferences =
                  respBidPreferences.data.totalEntries > 0
                    ? orderPreferences(respBidPreferences.data)
                    : respBidPreferences.data;
                const currentBid = openBids.entries.filter(
                  bid => bid.bidSessionId === Number(bidSessionId)
                )[0];
                if (bidMode) {
                  if (isWeightMode(bidMode) && currentBid !== undefined && currentBid.bidMode !== undefined) {
                    bidMode = currentBid.bidMode;
                  }
                  saveBidMode(bidMode);
                }
                let nextAvailableLevel;
                if (bidMode === BidMode.LADDER.biddingMode) {
                  nextAvailableLevel = getNextAvailableLevel(
                    bidPreferences,
                    bidLevels,
                    allowDuplicates
                  );
                }
                // check bid scope request
                if (bidScopeRequest) {
                  if (bidScopePreferenceOptions && bidScopePreferenceOptions.entries.length >= 1) displayScope = true
                }

                if (applyStandingBid && respBidPreferences.data) {
                  // Fetch both reserve line type and other options after standing bid import
                  // to ensure waivers are enabled correctly
                  Promise.all([
                    getReserveLineType(bidSessionId, staffId, categoryId)(),
                    apiCall(getOtherOptionsUrl)
                  ]).then(([reserveLineResponse, otherOptionsResponse]) => {
                    reserveLine = reserveLineResponse.data;
                    const updatedOtherOptions = otherOptionsResponse.data;
                      getLastSavedDate(
                        user,
                        currentBid,
                        bidPreferences,
                        updatedOtherOptions,
                        filters,
                        activePreferenceOptionsIds,
                        bidMode,
                        bidLevels,
                        nextAvailableLevel,
                        crewinterfacemode,
                        reserveLine,
                        configureReserveLineType,
                        displayDayOffOption,
                        displayRequestOptions,
                        displayScope,
                        pairings,
                        scores,
                        layoverHotelInformation
                      );
                    })
                } else {
                  getLastSavedDate(
                    user,
                    currentBid,
                    bidPreferences,
                    otherOptions,
                    filters,
                    activePreferenceOptionsIds,
                    bidMode,
                    bidLevels,
                    nextAvailableLevel,
                    crewinterfacemode,
                    reserveLine,
                    configureReserveLineType,
                    displayDayOffOption,
                    displayRequestOptions,
                    displayScope,
                    pairings,
                    scores,
                    layoverHotelInformation
                  );
                }
              }
            )
          )
          .catch(error => dispatch(fetchBidSessionFailure(error)));
      }
    }

    function getUserInformation() {
      const userRequestUrl = `employees/${staffId}`;
      apiCall(userRequestUrl)
        .then(response => {
          const user = response.data;
          sessionStorage.setItem(
            'chk',
            JSON.stringify(user.loadStanding) || null
          );
          getBidsAndPreferences(user);
        })
        .catch(error => dispatch(fetchBidSessionFailure(error)));
    }
    dispatch(fetchBidSessionRequest());
    getUserInformation();
  };
}

export const fetchBidPreferences = (staffId, bidSessionId) => {
  return () => {
    const lang = sessionStorage.getItem('lng') === 'fr' ? 'fr' : 'en';
    const baseUserRequestUrl = `preferences/bid-session/${bidSessionId}/employee/${staffId}/${lang}`;
    const userRequestUrl = buildUrlWithAdminImpersonation(baseUserRequestUrl);

    return apiCall(userRequestUrl);
  }
}

export const fetchPreviousBidSession = (staffId, categoryId, propertyCode, applicationType, bidSessionId, defaultBidSessionImport = false) => {
  return () => {
    const url = `preferences/previousBidSessions?staffId=${staffId}`;
    const payload = { staffId, categoryId, closed: true, propertyCode, applicationType, bidSessionId, defaultBidSessionImport }
    return apiCall(url, 'POST', payload);
  }
}

export const importPreviousBidPreferences = (staffId, currentBidSessionId, previousBidSessionId, bids) => {
  return () => {
    const baseUrl = `preferences/importBids`;
    const url = buildUrlWithAdminImpersonation(baseUrl);
    const payload = { staffId, currentBidSessionId, previousBidSessionId, bids };

    return apiCall(url, 'post', payload)
  }
}
